export enum RulesConstants {
  RULES_DOC = 'rules',
  RULES_RETURN = 'return ',
  DO_RUN_RULES = 'rules/DO_RUN_RULES',
}
